import { AvailableBudget, CreditsOverview } from 'src/dto/Credits';
import { baseApiWithCompanyId } from 'src/redux/services/baseApi';

const creditsApi = baseApiWithCompanyId.injectEndpoints({
  endpoints: (builder) => ({
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    getAvailableBudget: builder.query<AvailableBudget, void>({
      query: () => ({
        url: '/v1/credits/report/available',
      }),
      providesTags: ['AvailableBudget'],
    }),
    getCreditsOverview: builder.query<CreditsOverview, { start_date?: string; end_date?: string }>({
      query: (params) => ({
        url: '/v1/analytics/usage-detail-solution',
        params,
      }),
      providesTags: ['CreditsOverview'],
    }),
    getCreditsReportAsCost: builder.query<CreditsOverview, { start_date?: string; end_date?: string }>({
      query: (params) => ({
        url: '/v1/credits/report',
        params,
      }),
      providesTags: ['CreditsReporsAsCost'],
    }),
  }),
});

export const { useGetAvailableBudgetQuery, useGetCreditsOverviewQuery, useGetCreditsReportAsCostQuery, useLazyGetAvailableBudgetQuery } = creditsApi;
